import { render } from "./gdfx.vue?vue&type=template&id=33fefb9f&scoped=true&ts=true"
import script from "./gdfx.vue?vue&type=script&lang=ts"
export * from "./gdfx.vue?vue&type=script&lang=ts"

import "./gdfx.vue?vue&type=style&index=0&id=33fefb9f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fefb9f"]])

export default __exports__